import {createReducer} from '../../base/fsa/createReducer';
import {initialUIState} from './state';
import {
    changeBusyAction,
    setAuthenticationAction,
    setPopupScreenAction,
    setMediaScreenAction,
    setThemeAction,
    toggleScenarioPopupScreenAction,
    toggleScenarioScreenAction,
    toggleScenarioTriggerScreenAction,
    toggleScenarioTriggerPopupScreenAction,
    toggleScenarioTriggerInputScreenAction,
    setMediaFileListAction,
    setApplicationLoaded,
    alarmSettingUpAction,
    setSelectedBackgroundAction,
    toggleScenarioSTPUIInputScreenAction,
    setSTPUIMediaScreenAction,
    backButtonToggle, scenarioSettingAction, groupSettingAction, groupToggle, toggleScenarioFooterPopupScreenAction, setAlarmPasswordPopupScreenAction,
    toggleScenarioFrameUIInputScreenAction,
    passwordCheckingTimeoutAction,
    dateTimeAction,
} from './actions';
import {MediaModel} from '../../types/control';
import {entityCreatedAction, entityUpdatedAction} from '../control/actions';
import {ScenarioModel, ScenarioTriggerModel} from '../control/state';

export const uiReducer = createReducer(initialUIState, handle => [
    handle(changeBusyAction, (state, action) => {
        let busyCount = state.busyCount + (action.payload.busy ? 1 : -1);
        if (busyCount < 0) {
            busyCount = 0;
        }

        return {
            ...state,
            busyCount,
            busy: busyCount > 0,
        };
    }),
    handle(alarmSettingUpAction, (state, action) => {
        return {
            ...state,
            alarmSettingUp: action.payload,
        };
    }),
    handle(setMediaScreenAction, (state, action) => {
        return {
            ...state,
            mediaScreen: {
                ...state.mediaScreen,
                visible: !!action.payload.media,
                selectedMedia: action.payload.media,
                editMode: action.payload.editMode,
            },
        };
    }),
    handle(setThemeAction, (state, action) => {
      return {...state, ...action.payload}
    }),
    handle(setSTPUIMediaScreenAction, (state, action) => {
        return {
            ...state,
            stpUIMediaScreen: {
                ...state.mediaScreen,
                visible: !!action.payload.stpUIMedia,
                selectedMedia: action.payload.stpUIMedia,
            },
        };
    }),
    handle(toggleScenarioScreenAction, (state, action) => {
        return {
            ...state,
            scenarioScreen: {
                ...state.scenarioScreen,
                visible: !state.scenarioScreen.visible,
                selectedScenario: action.payload.scenario,
            },
        };
    }),
    handle(toggleScenarioTriggerScreenAction, (state, action) => {
        return {
            ...state,
            triggerScreen: {
                ...state.triggerScreen,
                visible: !state.triggerScreen.visible,
                selectedTrigger: action.payload.trigger,
            },
        };
    }),
    handle(toggleScenarioTriggerInputScreenAction, (state, action) => {
        return {
            ...state,
            triggerControlScreen: {
                ...state.triggerControlScreen,
                selectedTrigger: action.payload.input,
                selectedUIEntity: null,
            },
        };
    }),
    handle(toggleScenarioSTPUIInputScreenAction, (state, action) => {
        return {
            ...state,
            triggerControlScreen: {
                ...state.triggerControlScreen,
                selectedUIEntity: action.payload.uiEntity,
                selectedTrigger: null,
            },
        };
    }),
    handle(toggleScenarioFrameUIInputScreenAction, (state, action) => {
        return {
            ...state,
            triggerControlScreen: {
                ...state.triggerControlScreen,
                selectedUIEntity: action.payload.uiEntity,
                selectedTrigger: null,
            },
        };
    }),
    handle(toggleScenarioPopupScreenAction, (state, action) => {
        return {
            ...state,
            scenarioPopupScreen: {
                ...state.scenarioScreen,
                visible: !!action.payload.scenario,
                selectedScenario: action.payload.scenario,
            },
        };
    }),
    handle(toggleScenarioFooterPopupScreenAction, (state, action) => {
        return {
            ...state,
            scenarioFooterPopupScreen: {
                ...state.scenarioScreen,
                visible: !!action.payload.scenario,
                selectedScenario: action.payload.scenario,
            },
        };
    }),
    handle(toggleScenarioTriggerPopupScreenAction, (state, action) => {
        return {
            ...state,
            triggerPopupScreen: {
                ...state.triggerPopupScreen,
                visible: !!action.payload.trigger,
                selectedTrigger: action.payload.trigger,
            },
        };
    }),
    handle(entityUpdatedAction, (state, action) => {
        if (action.payload.type === 'scenario') {
            return {
                ...state,
                scenarioPopupScreen: {
                    ...state.scenarioPopupScreen,
                    ...(state.scenarioPopupScreen.selectedScenario != null && state.scenarioPopupScreen.selectedScenario.id === action.payload.entity.id ? {selectedScenario: action.payload.entity as ScenarioModel} : {}),
                },
                scenarioScreen: {
                    ...state.scenarioScreen,
                    ...(state.scenarioScreen.selectedScenario != null && state.scenarioScreen.selectedScenario.id === action.payload.entity.id ? {selectedScenario: action.payload.entity as ScenarioModel} : {}),
                },
            };
        }

        if (action.payload.type === 'scenarioTrigger') {
            return {
                ...state,
                triggerPopupScreen: {
                    ...state.triggerPopupScreen,
                    ...(state.triggerPopupScreen.selectedTrigger != null && state.triggerPopupScreen.selectedTrigger.id === action.payload.entity.id ? {selectedTrigger: action.payload.entity as ScenarioTriggerModel} : {}),
                },
                triggerScreen: {
                    ...state.triggerScreen,
                    ...(state.triggerScreen.selectedTrigger != null && state.triggerScreen.selectedTrigger.id === action.payload.entity.id ? {selectedTrigger: action.payload.entity as ScenarioTriggerModel} : {}),
                },
            };
        }

        if (action.payload.type === 'media') {
            return {
                ...state,
                mediaScreen: {
                    ...state.mediaScreen,
                    // @ts-ignore
                    ...((state.mediaScreen.selectedMedia != null && state.mediaScreen.selectedMedia.id === action.payload.entity.id) ? {selectedMedia: action.payload.entity as MediaModel} : {}),
                },
            };
        }

        return state;
    }),
    handle(setAuthenticationAction, (state, action) => {
        return {
            ...state,
            role: action.payload.role,
        };
    }),
    handle(setPopupScreenAction, (state, action) => {
        return {
            ...state,
            popupState: {
                ...state.popupState,
                ...action.payload,
            },
        };
    }),
    handle(setMediaFileListAction, (state, action) => {
        return {
            ...state,
            mediaFileList: action.payload.mediaFileList,
        };
    }),
     handle(dateTimeAction, (state, action) => {
        return {
            ...state,
            dateTime: action.payload.dateTime
        }
    }),
    handle(setApplicationLoaded, state => {
        return {
            ...state,
            applicationLoaded: true,
        };
    }),
    handle(setSelectedBackgroundAction, (state, action) => {
        return {
            ...state,
            selectedBackground: action.payload.selectedBackground,
        };
    }),
    handle(entityCreatedAction, (s, a) => {
        if (!['mediaFile'].includes(a.payload.type)) {
            return s;
        }

        const key = a.payload.type + 'List';
        return {
            ...s,
            [key]: [...s[key], a.payload.entity],
        };
    }),
    handle(backButtonToggle, (state, action) => {
        return {
            ...state,
            backButton: action.payload.backButton,
        };
    }),
    handle(scenarioSettingAction, (state, action) => {
        return {
            ...state,
            scenarioSetting: action.payload.scenarioSetting,
        };
    }),
    handle(groupToggle, (state, action) => {
        return {
            ...state,
            groupToggle: action.payload.groupToggle,
        };
    }),
    handle(passwordCheckingTimeoutAction, (state, action) => {
        return {
            ...state,
            passwordTimeoutSycle: action.payload.passwordTimeoutSycle
        }
    }),
    handle(groupSettingAction, (state, action) => {
        return {
            ...state,
            groupSetting: action.payload.groupSetting,
        };
    }),
    handle(setAlarmPasswordPopupScreenAction, (state, action) => {
        return {
            ...state,
            popupAlarmPasswordState: {
                ...state.popupAlarmPasswordState,
                ...action.payload,
            },
        };
    }),
]);
